import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from "@angular/common/http"; 
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

import { defineCustomElements, applyPolyfills } from '@bds/bds-core/loader';
import { BdsNgModule } from '@bds/bds-ng';

import { AppRoutingModule } from './app-routing.module';
import { HRBMicroAppLoaderDirective } from './shared/directives/hrblock-micro-app-loader-directive';
import { DataService } from './shared/services/data.service';
import { AppComponent } from './app.component';
import { CartPageComponent } from './cart-page/cart-page.component';
import { BillingPageComponent } from './billing-page/billing-page.component';
import { ConfirmationPageComponent } from './confirmation-page/confirmation-page.component';
import { AutoRenewalTermsPageComponent } from './auto-renewal-terms-page/auto-renewal-terms-page.component';
import { TaxIdentityShieldTermsPageComponent } from './tax-identity-shield-terms-page/tax-identity-shield-terms-page.component';
import { TermsPageComponent } from './terms-page/terms-page.component';
import { PreOrderBannerComponent } from './pre-order-banner/pre-order-banner.component';
import { getParams } from './shared/utils';

@NgModule({
  declarations: [
    AppComponent,
    CartPageComponent,
    BillingPageComponent,
    ConfirmationPageComponent,
    AutoRenewalTermsPageComponent,
    TaxIdentityShieldTermsPageComponent,
    TermsPageComponent,
    PreOrderBannerComponent,
    HRBMicroAppLoaderDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BdsNgModule
  ],
  exports: [
    HRBMicroAppLoaderDirective
  ],
  providers: [DataService, 
    {provide: 'BASE_URL', useFactory: getBaseUrl},
    {provide: 'TAX_YEAR', useFactory: getUrlTaxYear},
    {provide: 'SERVICE_ID', useFactory: getServiceId},
    {provide: 'PRICE_GROUP_KEY', useFactory: getPriceGroupKey},
    {provide: 'SKU', useFactory: getSku},
    {provide: 'STATE', useFactory: getState},
    {provide: 'PROMO_CODE', useFactory: getPromoCode},
    {provide: 'OTP_PARTNER_ID', useFactory: getOtpPartnerId}],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
    applyPolyfills().then(() => {
      defineCustomElements(window);
    });
  }
}

export function getBaseUrl() {
  return `${location.protocol}//${location.host}`;
}

export function getPromoCode() {
  const params : any = getParams(location.href)
  const promoCodeLength = params.promocode ?  params.promocode.length : 0;
  if (params.promocode !== undefined && promoCodeLength > 0)
    return params.promocode;
  else
    return '';
}

export function getUrlTaxYear() {
  const params : any = getParams(location.href)
  const taxYearLength = params.taxYear ?  params.taxYear.length : 0;
  if (params.taxYear !== undefined && taxYearLength > 0)
    return params.taxYear;
  else
    return 2020;
}

export function getState() {
  const params : any = getParams(location.href);
  const stateLength = params.state ? params.state.length : 0;
  if (params.state !== undefined && stateLength > 0)
    return `${params.state}`.toUpperCase();
  else
    return '';
}

export function getSku() {
  const params : any = getParams(location.href)
  return params.sku;
}

export function getPriceGroupKey() {
  const params : any = getParams(location.href);
  const priceGroupKeyLength = params.pricegroupkey ?  params.pricegroupkey.length : 0;
  if(params.pricegroupkey !== undefined && priceGroupKeyLength > 0)
    return params.pricegroupkey;
  else
    return ' ';
}

export function getServiceId() {
  return uuidv4();
}

export function getOtpPartnerId() {
  const params : any = getParams(location.href)
  return params.otppartnerid;
}